import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00f6a6d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-flex-1 tw-justify-center" }
const _hoisted_2 = { class: "tw-flex tw-w-full tw-h-full tw-px-[5px] tw-items-center tw-justify-center" }
const _hoisted_3 = { class: "text tw-text-[11px] tw-font-medium tw-truncate" }


export default /*#__PURE__*/_defineComponent({
  __name: 'cellTableResultStatus',
  props: {
    itemStatusId: {},
    title: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(`tw-inline-block tw-min-h-[20px] tw-w-max tw-rounded status status-${_ctx.itemStatusId}`)
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title || "N/A"), 1)
      ])
    ], 2)
  ]))
}
}

})